
/**
 * Is the given URL going to Sideline?
 *
 * We don't really care about the path, just the host. So you can pass in
 * 'https://sidelinehd.com' and this will work; it'll also work if you pass in
 * 'https://sidelinehd.com/api/team/blah'
 *
 * @param url URL to check -- must contain the host, so it can't just be a path.
 */
function isSidelineRequest(url: string): boolean {
  const hosts = [
    'shd-001.appspot.com',
    'sidelinehd.com',
    'shd-web-dev-001.appspot.com',
    'shd-web-dev-001.web.app',
    'localhost',
  ];
  return hosts.some((host) => {
    return url.indexOf(host) != -1;
  });
}

export default isSidelineRequest;
